import { useEffect, useState } from "react";
import { clsx } from "clsx";
import { Spinner } from "@/components/ui/Spinner";
import { EmptyState, SubTabs } from "@/features/power_projects/components/ui";
import { usePageTitle } from "@/hooks/usePageTitle";
import { useAnalysis, useAnalysisContractors } from "../hooks";
import { AnalysisPanel } from "../components/AnalysisPanel";
import { ErrorLine, INPUT_SM, fmtDate } from "../components/common";

type Window = "7" | "14" | "30" | "60";

/** Kontrola procesu › Podwykonawcy — rozliczenie firmy prowadzącej projekty ZE:
 *  co realnie zrobiła w oknie (dowody), co wymaga uwagi, kafle przed/po. Ten sam
 *  układ, co „Analiza postępów” osoby — tylko firma zamiast człowieka. */
export function ContractorAnalysisSection() {
  const { data: contractors, isLoading: loadingC } = useAnalysisContractors();
  const [contractor, setContractor] = useState<string | null>(null);
  const [days, setDays] = useState<Window>("14");
  useEffect(() => { if (!contractor && contractors?.[0]) setContractor(contractors[0].id); }, [contractors, contractor]);
  const { data, isLoading, error } = useAnalysis(contractor, Number(days));

  return (
    <div className="space-y-4">
      <div className="flex flex-wrap items-center gap-4 text-[13px]">
        <label className="inline-flex items-center gap-2">
          <span className="section-label">firma</span>
          <select className={clsx(INPUT_SM, "w-auto min-w-[16rem]")} value={contractor ?? ""} onChange={(e) => setContractor(e.target.value || null)} disabled={loadingC}>
            {(contractors ?? []).map((c) => <option key={c.id} value={c.id}>{c.name} ({c.projects})</option>)}
          </select>
        </label>
        <SubTabs<Window> active={days} onChange={setDays} tabs={[{ key: "7", label: "7 dni" }, { key: "14", label: "14 dni" }, { key: "30", label: "30 dni" }, { key: "60", label: "60 dni" }]} />
        {data && <span className="section-label">od {fmtDate(data.window.since)} do {fmtDate(data.window.until)}</span>}
      </div>
      {!contractors?.length && !loadingC && <div className="card"><EmptyState>Żaden projekt ZE nie jest obecnie prowadzony przez podwykonawcę</EmptyState></div>}
      {isLoading && <div className="flex h-40 items-center justify-center"><Spinner /></div>}
      {error && <ErrorLine error={error} />}
      {data && <AnalysisPanel data={data} />}
    </div>
  );
}

export function ContractorAnalysisPage() {
  usePageTitle("Analiza postępów podwykonawcy");
  return (
    <div>
      <h1 className="mb-3 text-xl font-bold">Analiza postępów podwykonawcy</h1>
      <ContractorAnalysisSection />
    </div>
  );
}
